import React from 'react';

const FooterDetails = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-title">FINE NET LTD.</p>
        <p className="footer-copy">&copy; FineSoft - All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterDetails;
